// Honest failure state (TASK-602). The third state every data-fetching surface
// must have: visually distinct from "empty" — the server DIDN'T answer, we are
// not claiming all-clear. Used by the Do panel, canvas widgets, Documents and
// KYC panes.
import { AlertTriangle, RotateCw } from 'lucide-react';

interface WidgetErrorStateProps {
  title: string;
  detail?: string;
  onRetry?: () => void;
  className?: string;
}

export function WidgetErrorState({ title, detail, onRetry, className = '' }: WidgetErrorStateProps) {
  return (
    <div
      role="alert"
      data-testid="widget-error-state"
      className={`flex flex-col items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-center ${className}`}
    >
      <AlertTriangle className="h-6 w-6 text-red-500" aria-hidden />
      <p className="text-sm font-medium text-red-800">{title}</p>
      {detail && <p className="text-xs text-red-600">{detail}</p>}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 inline-flex items-center gap-1 rounded-md border border-red-300 bg-white px-3 py-1 text-xs font-medium text-red-700 transition-colors hover:bg-red-100"
        >
          <RotateCw className="h-3 w-3" />
          Retry
        </button>
      )}
    </div>
  );
}

export default WidgetErrorState;
